module.exports = __webpack_public_path__ + "static/media/roshdy.3daebf39.jpeg";